import "./style.css";
import React, { useState, useEffect, useContext } from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import Logo from "../../../../resources/logo.png";
import midFadeImg from "../../../../resources/novi_fade_unutra_1.jpg";
import lowFadeImg from "../../../../resources/novi_fade_unutra_2.jpg";
import { CartContext } from "../../../../context/CartContext";
import { host } from "../../../../config/Config";
import EducationBreadcrumb from "../../../../common/EducationBreadcrumb";

export const Fade = () => {
    const phoneNumber = "+381 60-3859-426";
    const { addToCart } = useContext(CartContext);
    const [price, setPrice] = useState(0);
    const [loading, setLoading] = useState(true);
    const [hasAvailableSlots, setHasAvailableSlots] = useState(false);
    const [slotMessage, setSlotMessage] = useState("");
    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);

        // Trigger fade in after a brief delay
        setTimeout(() => {
            setFadeIn(true);
        }, 100);

        fetch(`${host}/api/v1/education-prices/type/fade`)
            .then((response) => response.json())
            .then((data) => {
                setPrice(data.price);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching price:", error);
                setPrice(50);
                setLoading(false);
            });

        fetch(`${host}/api/v1/education-slots/type/fade`)
            .then((response) => response.json())
            .then((slots) => {
                const activeSlots = slots.filter(
                    (slot) =>
                        slot.status === "ACTIVE" && slot.availableSlots > 0
                );
                if (activeSlots.length > 0) {
                    setHasAvailableSlots(true);
                } else {
                    setHasAvailableSlots(false);
                    const hasSlots = slots.some(
                        (slot) => slot.status === "ACTIVE"
                    );
                    setSlotMessage(
                        hasSlots
                            ? "Svi termini su trenutno popunjeni. Molimo kontaktirajte nas za više informacija."
                            : "Trenutno nema dostupnih termina za ovu edukaciju. Molimo kontaktirajte nas."
                    );
                }
            })
            .catch((error) => {
                console.error("Error fetching slots:", error);
                setHasAvailableSlots(false);
                setSlotMessage(
                    "Trenutno nema dostupnih termina za ovu edukaciju."
                );
            });
    }, []);

    const HandleOpenMap = () => {
        const url = `https://maps.app.goo.gl/6wxPp2i9rRZ45HQs6`;
        window.open(url, "_blank");
    };

    return (
        <div className='page-fade'>
            <EducationBreadcrumb />

            <div className={`items-fade ${fadeIn ? "fade-in" : ""}`}>
                <h1
                    style={{
                        fontSize: "37px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Fade
                </h1>
                <h1 style={{ marginTop: "-19px" }}>Nivo 4</h1>
                <p>
                    Napredna četvorodnevna edukacija posvećena je Fade tehnikama
                    svih tipova prelaza. Namenjena je barberima koji žele da
                    unaprede preciznost, kontrolu i tehničko razumevanje rada sa
                    mašinicama.
                </p>

                <img
                    src={lowFadeImg}
                    style={{
                        width: "80%",
                        height: "auto",
                        borderRadius: "15px",
                        border: "3px solid #be9455",
                        marginTop: "20px",
                        marginBottom: "10px",
                    }}
                    alt='Low Fade'
                />

                <p
                    style={{
                        textAlign: "center",
                        marginTop: "10px",
                        marginBottom: "15px",
                    }}
                >
                    Tokom programa ove radionice prolazi se kroz sve Fade
                    varijacije
                </p>

                <p
                    style={{
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Dan 1 - Taper Fade
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    Svaladavanje suptilnih prelaza i mekih detalja.
                </p>

                <p
                    style={{
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Dan 2 - Low Fade
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    Balansirajuća struktura sa niskom gradacijom.
                </p>

                <p
                    style={{
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Dan 3 - Mid Fade
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    Srednji prelaz, usavršavanje simetrije i konturiranje oblika
                    kroz srednji nivo.
                </p>

                <p
                    style={{
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Dan 4 - High Fade
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    Smeli kontrasti i snažan vizuelni uticaj.
                </p>

                <div
                    style={{
                        width: "80%",
                        overflow: "hidden",
                        borderRadius: "15px",
                        border: "3px solid #be9455",
                        marginTop: "20px",
                        marginBottom: "20px",
                    }}
                >
                    <img
                        src={midFadeImg}
                        style={{
                            width: "100%",
                            height: "auto",
                            transform: "scale(1.3)",
                        }}
                        alt='Mid Fade'
                    />
                </div>

                <p style={{ fontSize: "22px", marginTop: "30px" }}>
                    Svaki dan je podeljen u tri ključne faze.
                </p>
                <p style={{ fontSize: "22px", marginBottom: "-10px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Teorija - Rad sa mašinicama, struktura Fade, kontrola sečiva
                    i sistemi vođenja iste.
                </p>
                <p style={{ fontSize: "22px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Demonstracija - izvođenje uživo svakog tipa Fade-a sa
                    detaljnim objašnjenjima tehnika i pristupa.
                </p>
                <p style={{ fontSize: "22px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Praktična vežba - Učesnici će raditi na modelima
                    usavršavajući prelaze pomoću profesionalnih mašinica.
                </p>

                <img
                    src={Logo}
                    style={{ width: "140px", borderRadius: "8px" }}
                />

                <p style={{ fontSize: "22px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Do kraja Fade-a učesnici će otići sa sveobuhvatnim
                    razumevanjem Fade, sa velikim samopouzdanjem koristeći
                    mašinicu kao precizan alat i moći će da primene tehnike u
                    komercijalnim i privatnim okruženjima.
                </p>
                <p style={{ fontSize: "22px", marginBottom: "40px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Svi materijali i profesionalne lutke su uključeni u cenu.
                </p>

                {!loading && (
                    <div
                        style={{
                            textAlign: "center",
                            fontSize: "32px",
                            fontWeight: "bold",
                            color: "#be9455",
                            marginTop: "30px",
                            marginBottom: "10px",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        Cena: {price.toLocaleString()} EUR
                    </div>
                )}

                <div
                    className={`buy-button-fade ${
                        !hasAvailableSlots ? "disabled" : ""
                    }`}
                    onClick={() => {
                        if (hasAvailableSlots) {
                            addToCart({
                                id: "fade",
                                name: "Fade Workshop",
                                price: price,
                                category: "workshop",
                            });
                        }
                    }}
                    style={{
                        opacity: hasAvailableSlots ? 1 : 0.5,
                        cursor: hasAvailableSlots ? "pointer" : "not-allowed",
                    }}
                >
                    <p>{hasAvailableSlots ? "Dodaj u korpu" : "Nedostupno"}</p>
                </div>
                {slotMessage && (
                    <p
                        style={{
                            color: "#e74c3c",
                            textAlign: "center",
                            marginTop: "10px",
                            fontSize: "19px",
                            fontStyle: "italic",
                        }}
                    >
                        {slotMessage}
                    </p>
                )}
            </div>

            <a
                className='barbershop-zajednica-footer-title-adresa'
                onClick={HandleOpenMap}
                target='_blank'
                rel='noopener noreferrer'
            >
                <div>
                    <h2>Srpskog sovjeta 1a</h2>
                    <h2>11300, Smederevo</h2>
                    <h2> Klikni me</h2>
                </div>
            </a>
            <div className='barbershop-zajednica-footer-title-adresa'>
                <h2>Posetite Instagram</h2>
                <a
                    href='https://www.instagram.com/_zajednica_/'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                        marginTop: "10px",
                        width: "100%",
                        justifyContent: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        color: "#f3f3f3",
                        textDecoration: "none",
                    }}
                >
                    <InstagramIcon
                        style={{ color: "#f3f3f3", fontSize: "40px" }}
                    />
                </a>
            </div>

            <div className='barbershop-zajednica-footer-title'>
                <h2>Ili nas kontaktirajte</h2>
            </div>
            <div className='barbershop-zajednica-footer-phone'>
                <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </div>
        </div>
    );
};
